<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow"> 
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
        <el-form-item size="small" style="width:19%">
    		<el-date-picker v-model="signquery.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="orderisselect=true" style="width:100%"   :unlink-panels="false"></el-date-picker>
    	</el-form-item>
        <el-form-item>
		  	<el-select v-model="signquery.clerkid" placeholder="请选择职员" prop="groupid" clearable>
		      	<el-option v-for="(item,index) in alllists" :label="item.name" :value="item.id" :key="index"></el-option>
		    </el-select>
	    </el-form-item>
        <el-form-item>
			<el-select v-model="signquery.customername" clearable filterable remote reserve-keyword :remote-method="getCustomer" :loading="customerLoading" placeholder="客户名称 / 简称 / 客户手机" @change="changecustomer">
			    <el-option v-for="(item,index) in customerLists" :key="index" :label="item.showname" :value="item.id"></el-option>
			</el-select> 
		</el-form-item>	      
	    <el-form-item>
	      	<el-button type="primary" icon="el-icon-search" @click="getsignList">查询</el-button>
            <el-button type="warning" icon="el-icon-search" @click="getvisitlists">拜访计划管理</el-button>
	      	<el-button type="primary" icon="el-icon-download" @click="getsignexport">导出</el-button>
	    </el-form-item>
      </el-form>
      
      <div class="backborder2" style="margin-top:10px">
          <el-table :data="signlists" v-loading="runLoading">
              <el-table-column label="id" prop="id" width="90" />
              <el-table-column label="拜访信息">
                    <template slot-scope="scope">
                        <span style="float:left;width:100%;font-size:13px">{{scope.row.customer_name}}</span>
                        <span style="float:left;width:100%;font-size:12px;color:#999999;" v-if="scope.row.inputtime!=''">拜访时间：{{scope.row.inputtime}}</span>
                    </template>
              </el-table-column>
              <el-table-column label="拜访人" width="250">
                    <template slot-scope="scope">
                        <span style="float:left;width:100%;font-size:13px;">{{scope.row.clerkname}}</span>
                    </template>
              </el-table-column>
              <el-table-column label="签到地点" width="350">
                    <template slot-scope="scope" v-if="scope.row.address!=''">
                        <div style="float:left;width:100%;display:flex;justify-content:left;align-items:center;">
                            <div style="font-size:13px;line-height:23px;color:#666666;">{{scope.row.address}}</div>
                            <a style="width:18px;height:18px;margin-left:2%;cursor:pointer" @click="shopmap(scope.row.lat,scope.row.log,scope.row.customer_name,scope.row.address)">
                                <img src="../../assets/address_green.png" style="float:left;width:18px;height:18px;"/>
                            </a>
                            <a style="width:18px;height:18px;margin-left:2%;cursor:pointer" @click="checkimgs(scope.row)" v-if="scope.row.images.length > 0">
                                <img src="../../assets/img_green.png" style="float:left;width:18px;height:18px;"/>
                            </a>
                        </div>
                        <div style="float:left;width:100%;color:#999999;font-size:12px;line-height:23px;">拜访内容：{{scope.row.note}}</div>
                    </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="150">
              <template slot-scope="scope">
                  <el-button type="" size="small" round @click="delsign(scope.row)">删除</el-button>
              </template>
              </el-table-column>
          </el-table>        

          <div class="block">
	          <!--分页begin-->
	          <el-pagination
	            @size-change="signpageSizeChange"
	            @current-change="signpageCurrentChange"
	            :current-page="signquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="signquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="sign_total_rows">
	          </el-pagination>
	          <!--分页end-->
          </div> 
	  </div>


    <!------ 新增 / 编辑跑店记录 ---------->
    <el-dialog title="新增/编辑跑店记录" :visible.sync="addsignDialog" top="5vh" width="35%">
	      <el-form :inline="true" class="demo-form-inline" size="small">
            <el-form-item size="small" label="拜访期限" label-width="120">
                <el-date-picker v-model="createsign.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :unlink-panels="false"></el-date-picker>
            </el-form-item>
            <el-form-item size="small" label="拜访客户" label-width="120">
                <el-select v-model="createsign.customerid" clearable filterable remote reserve-keyword :remote-method="getCustomer" :loading="customerLoading" placeholder="客户名称 / 简称 / 客户手机" style="width:100%">
		          	    <el-option v-for="(item,index) in customerLists" :key="index" :label="item.showname" :value="item.id"></el-option>
		            </el-select> 
            </el-form-item>
            <el-form-item size="small" label="拜访人员" label-width="120">
                <el-select v-model="createsign.clerkid" placeholder="请选择销售员" clearable>
                    <el-option v-for="(item,index) in alllists" :label="item.name" :value="item.id" :key="index"></el-option>
                </el-select>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
			<el-button size="small" @click="addsignDialog = false">取 消</el-button>			        
			<el-button size="small" type="primary" @click="createnoSave">保 存</el-button>
		</div>
	  </el-dialog>


      <el-dialog title="拜访记录图" :visible.sync="imgDialog" top="5vh" width="45%">
        <div style="float:left;width:100%;margin-bottom:5px" v-for="(item,index) in imglists" :key="index">
            <img :src="item"  style="float:left;width:100%;padding:5px;border:1px solid #dddddd;border-radius:15px"/>
        </div>
        <div slot="footer" class="dialog-footer">
			<el-button size="small" @click="imgDialog = false">取 消</el-button>			        
		</div>
      </el-dialog>


      <el-dialog title="拜访计划管理" :visible.sync="visitDialog" top="5vh" width="85%"> 
        <el-form :inline="true" class="demo-form-inline" size="small"> 
            <el-form-item>
                <el-select v-model="visitquery.timetype" @change="visitquery.ischange=true">
                    <el-option v-for="(item,index) in timetypelists" :label="item.name" :value="item.id" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item size="small">
                <el-date-picker v-model="visitquery.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="visitquery.ischange=true" style="width:100%"   :unlink-panels="false"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-select v-model="visitquery.isfinish" @change="visitquery.ischange=true" clearable>
                    <el-option v-for="(item,index) in isfinishlists" :label="item.name" :value="item.id" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="visitquery.clerkid" placeholder="请选择职员" filterable clearable @change="visitquery.ischange=true">
                    <el-option v-for="(item,index) in alllists" :label="item.name" :value="item.id" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="visitquery.customerid" clearable filterable remote reserve-keyword :remote-method="getCustomer" :loading="customerLoading" placeholder="客户名称 / 简称 / 客户手机" @change="visitquery.ischange=true">
                    <el-option v-for="(item,index) in customerLists" :key="index" :label="item.showname" :value="item.id"></el-option>
                </el-select> 
            </el-form-item>
            <el-form-item>
	      	    <el-button type="primary" icon="el-icon-search" circle size="mini" @click="getvisitdatas"></el-button>
                <el-button type="danger" icon="el-icon-plus" circle size="mini" @click="addsign"></el-button>
	        </el-form-item>
        </el-form>

        <el-table :data="visitlists" v-loading="visitquery.loading">
            <el-table-column label="id" prop="id" width="90"/>
            <el-table-column label="计划拜访客户">
               <template slot-scope="scope">
                  <span style="float:left;font-size:13px">{{scope.row.customername}}</span>
                  <span style="font-size:12px;">{{scope.row.shopname}}</span>
                  <span style="float:left;width:100%;font-size:12px;color:#999999;">拜访人：{{scope.row.clerkname}}</span>
                  <span style="float:left;width:100%;font-size:12px;color:#F56C6C;">计划拜访时间：{{scope.row.expiretime}}</span>
               </template>
            </el-table-column>
            <el-table-column label="是否完成" width="150" align="center">
              <template slot-scope="scope">
                  <span style="float:left;width:100%;font-size:13px;">{{scope.row.isfinished==0 ? '未完成' : '已完成'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="拜访内容" width="150">
              <template slot-scope="scope">
                  <span style="width:100%;font-size:13px;ling-height:23px">{{scope.row.note}}</span>
              </template>
            </el-table-column>
            <el-table-column label="签到地点" width="350">
              <template slot-scope="scope" v-if="scope.row.address">
                  <span style="width:100%;font-size:13px;ling-height:23px">{{scope.row.address}}<i style="font-style:normal;color:#67C23A">（拜访时间：{{scope.row.inputtime}}）</i></span>
                  <el-button size="mini" type="success" icon="el-icon-location" style="padding:1px" circle @click="shopmap(scope.row.lat,scope.row.log,scope.row.customername,scope.row.address)"></el-button>
              </template>
            </el-table-column>
              <el-table-column label="操作" align="center" width="140">
                  <template slot-scope="scope">
                      <el-button type="warning" size="mini" circle icon="el-icon-edit" @click="getsign(scope.row)"></el-button>
                      <el-button type="danger" size="mini" circle icon="el-icon-delete" @click="delsign(scope.row)"></el-button>
                      <el-button type="primary" size="mini" circle icon="el-icon-picture-outline" @click="checkimgs(scope.row)" v-if="scope.row.images.length > 0"></el-button>
                  </template>
              </el-table-column>
          </el-table>        
          <div class="block">
	          <!--分页begin-->
	          <el-pagination
	            @size-change="visitpageSizeChange"
	            @current-change="visitpageCurrentChange"
	            :current-page="visitquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="visitquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="visitrows">
	          </el-pagination>
	          <!--分页end-->
          </div>

        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="visitDialog = false">取 消</el-button>			        
        </div>
      </el-dialog>


      <!-------------- 展示地图信息 ------------------->
	  <el-dialog title="百度地图" :visible.sync="showmapDialog" top="5vh" width="55%">
	      <template>
			  <baidu-map class="bm-view" :center="center" :zoom="zoom" @ready="handler" :scroll-wheel-zoom="true" v-loading="mapLoading">
    			  <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="false" :autoLocation="true" :locationIcon="{size: {width: 18, height: 18}}" @locationSuccess="getLoctionSuccess" @locationError="getLocationError"></bm-geolocation>
    			  <!-- 自定义定位图标覆盖物 -->
    			  <bm-marker :position="autoLocationPoint"  :dragging="true" :auto-viewport='true' animation="BMAP_ANIMATION_BOUNCE"  v-if="initLocation" :icon="{url:require('../../assets/baidu_marker_logo.png'),size:{width:32,height:32}}"></bm-marker>
  			  </baidu-map>			    
		  </template>
	  </el-dialog>
      
 
  </div>
  </transition>
</template>

<script>

export default {
  props:['childdata'],
  data () {
    return {
      actionauth:'', //操作权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Clerk/index",
      lists:[],
      alllists:[],
      listLoading:false,
      query:{
        act:'lists',
        token:this.$cookies.get('token'),
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      total_rows:0,
      signlists:[],
      signquery:{
        act:'getclerksign',
        token:this.$cookies.get('token'),
        p: 1,
        rollpage: 10, // 页大小
        clerkid:'',
        customerid:this.childdata.id ? this.childdata.id : '',
        customername:this.childdata.name ? this.childdata.name : '',
        date:[],
      },

      visittypelists:[{id:1,name:'普通拜访'},{id:2,name:'指定销售员拜访'}],
      runLoading:false,
      sign_total_rows:0,
      showmapDialog:false,
      center:'',
      zoom:'',
      autoLocationPoint: '',
      initLocation: false,
      mapLoading: false,
      signexportlists:[],
      signexportLoading:false,
      customerLists:[],
      customerLoading:false,

      addsignDialog:false,
      createsign: {
        act:'addsign',
        token:this.$cookies.get('token'),
        id:'',
        customerid:'',
        clerkid:'',
        date:[],
      },
      
      imgDialog:false,
      imglists:[],

      visitDialog:false,
      visitquery: {
        act:'getvisitlist',
        token:this.$cookies.get('token'),
        customerid:'',
        clerkid:'',
        isfinish:'',
        timetype:1,
        date:[],
        ischange:false,
        loading:false,
        p:1,
        rollpage:10,
      },
      timetypelists:[{id:1,name:'按计划时间'},{id:2,name:'按拜访时间'}],
      isfinishlists:[{id:1,name:'未完成'},{id:2,name:'已完成'}],
      visitlists:[],
      visitrows:0,

      
    }
  },
  mounted(){
      this.getactionauth();
      //this.getList(); //获取职员信息列表
      this.getsignList(); //获取跑店信息列表
      this.getallclerks(); //获取全部销售员信息
  },

  watch: {
    childdata(val) {
      this.signquery.customerid=val.id;
      this.signquery.customername=val.name;
      this.getsignList();
    }
  },

  methods:{  
  
  	/** 获取操作权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    /** 信息列表 **/
    getList(){
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
          if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	          this.listLoading = false;
          }else{
	          this.lists = JSON.parse(Base64.decode(res.data.Data));
	          this.total_rows=parseInt(res.data.count);
	          this.listLoading = false;
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },

    
    /** 获取全部销售员信息 **/
    getallclerks() {
        var resource = this.$resource(this.url);
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:10000000,p: 1}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                this.alllists = JSON.parse(Base64.decode(res.data.Data));
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },

    
    /** 跑店信息列表 **/
    getsignList(){   
        this.runLoading = true;
        var resource = this.$resource(this.GLOBAL.domain+"Shop/index");
        resource.query(this.signquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.signlists = JSON.parse(Base64.decode(res.data.Data));
	            this.sign_total_rows=parseInt(res.data.count);
	            this.runLoading = false;
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.runLoading=false;
        });
    },
    signpageSizeChange(val) {
        this.signquery.rollpage = val;
        this.getsignList();
    },
    signpageCurrentChange(val) {
        this.signquery.p = val;
        this.getsignList();
    },
    
    /** 地图展示 **/
    shopmap(lat,log,customer_name,address) {
        this.showmapDialog=true;
    	  let _this = this;  // 设置一个临时变量指向vue实例，因为在百度地图回调里使用this，指向的不是vue实例；
    	  this.zoom=15;

          this.center = {lng:log,lat:lat};   // 设置center属性值
          this.autoLocationPoint = {lng:log, lat:lat};   // 自定义覆盖物
          this.initLocation = true;           	
    },
    
    
    //导出跑店信息
    getsignexport() {
    	// if(this.signquery.date && this.signquery.date[0]=='') {this.$message.error("请选择开始日期");exit;}
    	// if(this.signquery.date && this.signquery.date[1]=='') {this.$message.error("请选择结束日期");exit;}

    	var url=this.GLOBAL.domain+"Shop/index/act/getclerksignexport/token/"+this.$cookies.get('token');
    	if(this.signquery.date.length > 0) url +="/start/"+this.signquery.date[0]+"/end/"+this.signquery.date[1]; 
    	if(this.signquery.clerkid > 0) url +="/clerkid/"+this.signquery.clerkid;
    	location.href=url;
    },


    /** 获取客户 **/
	    getCustomer(query){
	        if (query !== '') {
		        this.customerLoading = true;
		        var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
		        resource.query({act:'lists',key:query,token:this.$cookies.get('token'),p:1,rollpage:10000000}).then((res) => {
		            if(res.data.Result>0){
			            if(res.data.Result=='70001') this.$router.push('/login')
			            this.$message.error(res.data.Message);
			            this.customerLoading = false;
		            }else{
			            this.customerLists = JSON.parse(Base64.decode(res.data.Data));
			            this.customerLoading = false;
		            }
		        }).catch((res) => {
		            //this.$message.error(this.GLOBAL.errortext);
		            this.customerLoading = false;
		        });
	        }
	    },

      //修改客户
      changecustomer(val) {
        this.signquery.customerid=val;
      },


      /** 新增拜访计划 **/
      addsign() {
        this.addsignDialog=true;
        this.createsign.act='addsign';
        this.createsign.id='';
        this.createsign.customerid='';
        this.createsign.clerkid='';
        this.createsign.date=[];
      },

      /** 保存拜访计划 **/
      createnoSave() {
        var resource = this.$resource(this.GLOBAL.domain+"Shop/index");
        resource.save(this.createsign).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.addsignDialog=false;
                this.getvisitdatas();
	        }
        }).catch((res) => {

        });
      },

      /** 获取拜访计划 **/
      getsign(item) {
          this.addsignDialog=true;
          var resource = this.$resource(this.GLOBAL.domain+"Shop/index");
		      resource.query({act:'getsign',id:item.id,token:this.$cookies.get('token')}).then((res) => {
		          if(res.data.Result>0){
			            if(res.data.Result=='70001') this.$router.push('/login')
			            this.$message.error(res.data.Message);
		          }else{
			            var result = JSON.parse(Base64.decode(res.data.Data));
                        this.createsign.act='savesign';
                        this.createsign.id=result.id;
                        this.createsign.customerid=result.customerid;
                        this.createsign.clerkid=result.clerkid;
                        this.createsign.date=result.date;
                        this.getCustomer(result.customer_name);
		          }
		      }).catch((res) => {

		      });
      },

      /** 删除记录 **/
      delsign(item) {

        this.$confirm('你是否要删除该记录?', '提示', { type: 'warning' }).then(() => {
            var resource = this.$resource(this.GLOBAL.domain+"Shop/index");
            resource.query({act:'delsign',id:item.id,token:this.$cookies.get('token')}).then((res) => {
                if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{
                    this.getvisitdatas();
                }
            }).catch((res) => {

            });
        }).catch(() => {
            
        });
      },


      /** 查看拜访图片 **/
      checkimgs(item) {
          this.imgDialog=true;
          this.imglists=item.images;
      },  



      /** 获取拜访计划列表 **/
      getvisitlists() {
          this.visitDialog=true;
          this.visitquery.customerid='';
          this.visitquery.clerkid='';
          this.visitquery.timetype=1;
          this.visitquery.isfinish='';
          this.visitquery.date=[];
          this.visitquery.p=1;
          this.visitquery.rollpage=10;
          this.getvisitdatas();
      },

      /** 获取拜访任务信息列表 **/
      getvisitdatas() {
        if(this.visitquery.ischange) {
            this.visitquery.p=1;
            this.visitquery.rollpage=10;
        }
        
        this.visitquery.loading=true;
        var resource = this.$resource(this.GLOBAL.domain+"Shop/index");
        resource.save(this.visitquery).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.visitquery.loading=false;
            }else{
                this.visitlists = JSON.parse(Base64.decode(res.data.Data));
	            this.visitrows=parseInt(res.data.count); 
                this.visitquery.loading=false;  
                if(this.visitquery.ischange) this.visitquery.ischange=false;
            }
        }).catch((res) => {
            this.visitquery.loading=false;
        });        

      },
      visitpageSizeChange(val) {
          this.visitquery.rollpage = val;
          this.getvisitdatas();
      },
      visitpageCurrentChange(val) {
          this.visitquery.p = val;
          this.getvisitdatas();
      },


  }
}
</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/base/Clerkrun.vue